import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import DotboldIcon from '../../../assets/img/dotsbold.svg';
import { useAoneStore } from '../../../store/AoneStore';
import { useConfigStore } from "../../../store/ConfigMgt/ConfigStore";
import { useCrmStore } from "../../../store/CrmMgt/CrmStore";
import { showErrorToast, showSuccessToast } from '../../../components/Toast/Toaster';
import { DateRangePicker } from 'rsuite';
import { PaginationMainTable } from '../../../components/Tables/PaginationMainTable';
import Dropdown from 'react-bootstrap/Dropdown';
import SearchInput from '../../../components/dropdown/AutoCompleteInput';
import AsyncSearchInput from '../../../components/dropdown/AutoCompleteAsync';
import { UserContext } from '../../../helper/ProtectedRoute';
import TableComponent from '../Tables/CodPayables';
import CodPayableDetailModal from './CodPayableDetailModal';
import { useCodAutomationStore } from '../../../store/CodAutomation/codAutomationStore';
import { getTimezoneOffset } from '../../../services/axiosbase';
import { Button } from '../../../components/UI/button';
import { Label } from '../../../components/UI/label';
import { RefreshCw, Search } from 'lucide-react';
import '../../../styles/tailwind.css';
import '../../../styles/tailwind-shadcn-fixes.css';
import { useAbortableLoad } from '../../../components/UI/loading';

const CodPayables = ({ tab, setTab }) => {
    const [selectedOptionCustomer, setSelectedOptionCustomer] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [destinationCountry, setDestinationCountry] = useState(null);
    const [selectedOptionCountry, setSelectedOptionCountry] = useState(null);
    const [dateRange, setDateRange] = useState([]);
    const [dateRangefil, setDateRangefil] = useState({});
    const [codPayables, setCodPayables] = useState([]);
    const [newPage, setNewPage] = useState(0);
    const [size, setSize] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [checkedCol, setCheckedCol] = useState(['Disable', 'Deductible']);
    const [loadingMore, setLoadingMore] = useState(false);
    const [sortField, setSortField] = useState('-updatedAt');
    const [selectedRows, setSelectedRows] = useState([]);
    const [cusPage, setCusPage] = useState(-1);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [codPayableDetails, setCodPayableDetails] = useState(null);
    const [deductible, setDeductible] = useState(false);
    // List request: skeleton, Cancel and latest-wins ordering. The service
    // takes no AbortSignal, so Cancel drops the response.
    const listLoad = useAbortableLoad();
    const isLoadingPage = listLoad.loading;
    const [modalPage, setModalPage] = useState(0);
    const [modalSize, setModalSize] = useState(20);
    const [modalHasNext, setModalHasNext] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [isSummaryLoading, setIsSummaryLoading] = useState(false);
    const [modalSummaryItem, setModalSummaryItem] = useState(null);
    const modalViewItemRef = useRef(null);
    const modalCursorsRef = useRef([null]);

    const isReactselectRegion = useAoneStore((state) => state?.isReactselectRegion);
    const isReactdesBulk = useAoneStore((state) => state?.isReactdesBulk);
    const setReactSelectregion = useAoneStore((state) => state?.setReactSelectregion);
    const setReactDesBulk = useAoneStore((state) => state?.setReactDesBulk);
    const setisReactRatestate = useAoneStore((state) => state?.setisReactRatestate);

    const countriesData = useConfigStore((state) => state?.countriesData);
    const filterCustomer = useCrmStore((state) => state?.filterCustomer);
    const filterCountries = useConfigStore((state) => state?.filterCountries);
    const storedCountryCodes = JSON.parse(sessionStorage.getItem('countryCodes'));
    const matchedCountries = countriesData?.data?.data?.content?.filter(
        (country) => storedCountryCodes?.includes(country.isoCode3)
    );
    const getCodPayables = useCodAutomationStore((state) => state?.getCodPayables);
    const generateCodPayable = useCodAutomationStore((state) => state?.generateCodPayable);
    const getCodPayableDetails = useCodAutomationStore((state) => state?.getCodPayableDetails);
    const getCodPayableBySummaryId = useCodAutomationStore((state) => state?.getCodPayableBySummaryId);

    const [state] = useContext(UserContext);
    const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));
    useEffect(() => {
        setRole(state.roles);
    }, [state.roles]);

    const ref = useRef();
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
            setisReactRatestate(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    useEffect(() => {
        const startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date();
        endDate.setHours(23, 59, 59, 999);
        setDateRange([startDate, endDate]);
        const formatDate = (date) => date.getTime();
        setDateRangefil({ start: formatDate(startDate), end: formatDate(endDate) });
    }, []);

    const loadMoreOptions = useCallback(
        async (search) => {
            if (!loadingMore) {
                setLoadingMore(true);
                let nextPage = search ? 0 : cusPage + 1;
                if (nextPage === -1) nextPage = 0;
                setCusPage(nextPage);
                let endpoint = `?page=${nextPage}&size=20`;
                if (search) endpoint += `&customerAccount=${search}`;
                const response = await filterCustomer(endpoint);
                const options = response.data.data.content || [];
                setLoadingMore(false);
                return {
                    options: options.map((option) => ({
                        label: `${option.accountNumber} - ${option.name}`,
                        value: option.accountNumber,
                    })),
                    hasMore: options.length > 0,
                };
            }
            return { options: [], hasMore: false };
        },
        [loadingMore, cusPage]
    );

    useEffect(() => {
        let paramslink = `?page=${0}&size=${300}`;
        if (countriesData?.data?.data?.content?.length < 1 || countriesData?.length < 1) {
            filterCountries(paramslink);
        }
    }, []);

    const shouldLoadMore = (scrollHeight, clientHeight, scrollTop) => {
        const bottomBorder = (scrollHeight - clientHeight) / 2;
        return !loadingMore && bottomBorder < scrollTop;
    };

    const handleMenuOpenregion = () => setReactSelectregion(true);
    const handleMenuCloseregion = () => setReactSelectregion(false);
    const handleMenuOpenDesBulk = () => setReactDesBulk(true);
    const handleMenuCloseDesBulk = () => setReactDesBulk(false);

    const handlePaste = async (event) => {
        const pastedText = event.clipboardData.getData('text').trim();
        if (!pastedText) return;
        const accounts = pastedText.split(/[\s,]+/).filter((acc) => acc.length > 0);
        if (accounts.length === 0) return;
        const response = await filterCustomer(`?page=0&size=${accounts.length}&customerAccount=${accounts.join(',')}`);
        const options = response.data.data.content || [];
        if (options.length > 0) {
            const matchedOptions = options.map((option) => ({
                label: `${option.accountNumber} - ${option.name}`,
                value: option.accountNumber,
            }));
            setSelectedOptionCustomer((prev) => {
                if (Array.isArray(prev)) {
                    const newValues = matchedOptions.filter((opt) => !prev.some((p) => p.value === opt.value));
                    return [...prev, ...newValues];
                }
                return matchedOptions;
            });
            setCustomer((prev) => {
                const existing = prev ? prev.split(',') : [];
                const newVals = matchedOptions.map((opt) => opt.value);
                return [...new Set([...existing, ...newVals])].join(',');
            });
        }
    };

    const handleDateRangeChange = (value) => {
        if (value !== null) {
            setDateRange(value);
            const startDate = new Date(value[0]);
            startDate.setHours(0, 0, 0, 0);
            const endDate = new Date(value[1]);
            endDate.setHours(23, 59, 59, 999);
            const formatDate = (date) => date.getTime();
            setDateRangefil({ start: formatDate(startDate), end: formatDate(endDate) });
        } else {
            setDateRange([]);
            setDateRangefil([]);
        }
    };

    const getData = useCallback(async () => {
        try {
            const requestBody = {
                page: newPage,
                size,
                customers: customer ? customer.split(',').map((c) => c.trim()) : undefined,
                destinationCountry: destinationCountry || undefined,
                from: dateRangefil.start || undefined,
                to: dateRangefil.end || undefined,
                includeDeductible: deductible,
            };
            const data = await listLoad.track(() => getCodPayables(requestBody));
            setTotalCount(data?.data?.data?.totalElements);
            setCodPayables(data?.data?.data?.content);
        } finally {
        }
    }, [getCodPayables, newPage, size, customer, destinationCountry, dateRangefil, deductible]);

    const handleApplyFilters = () => {
        if (!dateRangefil.start || !dateRangefil.end) {
            showErrorToast('Date range must be selected to perform this action');
            return;
        }
        if (!destinationCountry) {
            showErrorToast('Destination country must be selected to perform this action');
            return;
        }
        getData();
    };

    useEffect(() => {
        if (codPayables?.length) {
            getData();
        }
    }, [newPage, size, sortField]);

    const handleRefresh = async () => {
        if (!dateRangefil.start || !dateRangefil.end) {
            showErrorToast('Date range must be selected to perform this action');
            return;
        }
        if (!destinationCountry) {
            showErrorToast('Destination country must be selected to perform this action');
            return;
        }
        getData();
    };

    /* The consignments come back cursor-paged: every response carries the cursor
       that opens the page after it, and nothing that walks backwards. The
       cursors are kept per page index so the previous button can re-ask for a
       page already seen; index 0 is the first page, which is asked for with no
       cursor at all. */
    const fetchModalData = useCallback(async (page, size, item) => {
        const target = item || modalViewItemRef.current;
        if (!target) return;
        setIsModalLoading(true);
        try {
            const cursor = modalCursorsRef.current[page] ?? null;
            const response = await getCodPayableDetails(target.customer, target.from, target.to, target.destinationCountry, size, cursor);
            if (response?.data?.status === 'SUCCESS') {
                const data = response?.data?.data;
                setCodPayableDetails(data);
                setModalHasNext(data?.hasNext ?? false);
                modalCursorsRef.current[page + 1] = data?.nextCursor ?? null;
            } else {
                showErrorToast(response?.response?.data?.msg || 'ERROR');
            }
        } catch (error) {
            showErrorToast(error?.msg || 'ERROR');
        } finally {
            setIsModalLoading(false);
        }
    }, [getCodPayableDetails]);

    /* The list row carries only what the grid needs. The payable itself carries
       the adjustment entries and the charge breakdown the sheet shows, so it is
       asked for by summary id alongside the consignments and merged over the
       row that opened the sheet. */
    const fetchPayableSummary = useCallback(async (summaryId) => {
        if (!summaryId) return;
        setIsSummaryLoading(true);
        try {
            const response = await getCodPayableBySummaryId(summaryId);
            if (response?.data?.status === 'SUCCESS') {
                const payable = response?.data?.data;
                if (payable) setModalSummaryItem((prev) => ({ ...(prev || {}), ...payable }));
            } else {
                showErrorToast(response?.response?.data?.msg || 'ERROR');
            }
        } catch (error) {
            showErrorToast(error?.msg || 'ERROR');
        } finally {
            setIsSummaryLoading(false);
        }
    }, [getCodPayableBySummaryId]);

    const handleViewClick = useCallback((item) => {
        const { summaryItem, ...viewParams } = item;
        modalViewItemRef.current = viewParams;
        modalCursorsRef.current = [null];
        setModalSummaryItem(summaryItem || null);
        setModalPage(0);
        setOpenViewModal(true);
        fetchModalData(0, modalSize, viewParams);
        fetchPayableSummary(summaryItem?.summaryId);
    }, [fetchModalData, fetchPayableSummary, modalSize]);

    const handleModalNextPage = () => {
        const next = modalPage + 1;
        setModalPage(next);
        fetchModalData(next, modalSize);
    };

    const handleModalPrevPage = () => {
        const prev = Math.max(0, modalPage - 1);
        setModalPage(prev);
        fetchModalData(prev, modalSize);
    };

    const handleModalSizeChange = (newSize) => {
        /* A different page size makes every cursor already collected point at
           the wrong row, so paging restarts from the first page. */
        modalCursorsRef.current = [null];
        setModalSize(newSize);
        setModalPage(0);
        fetchModalData(0, newSize);
    };

    const handleNextPage = () => setNewPage((prev) => prev + 1);
    const handlePreviousPage = () => setNewPage((prev) => Math.max(0, prev - 1));
    const handlePageSizeChange = (newSize) => { setSize(newSize); setNewPage(0); };

    const gridId = 'finance.codPayables';
    const [column, setColumn] = useState([
        'Customer Account',
        'Customer Name',
        'COD Collected',
        'Status',
        'Destination Country',
        'Bank Charges',
        'Payable Amount',
        'Email Sent',
        'From Date',
        'To Date',
        'Disable',
        'Deductible',
        'Action',
    ]);

    const handleSelect = (d) => {
        let val = checkedCol.includes(d);
        if (val) {
            setCheckedCol(checkedCol.filter((dat) => dat !== d));
        } else {
            setCheckedCol([...checkedCol, d]);
        }
    };

    const handleBulkGenerate = useCallback(async () => {
        try {
            const generateRequests = (codPayables || [])
                .filter((row) => selectedRows?.includes(row?.customer))
                .map((row) => ({
                    customerAccount: row?.customer,
                    summaryId: row?.summaryId,
                    from: row?.from ?? dateRangefil?.start,
                    to: row?.to ?? dateRangefil?.end,
                    destinationCountry: row?.destinationCountry ?? destinationCountry,
                    includeDeductible: row?.deductible ?? deductible,
                }));
            if (!generateRequests?.length) {
                showErrorToast('No rows selected to generate');
                return;
            }
            const response = await generateCodPayable({
                timezone: getTimezoneOffset(),
                generateRequests,
            });
            if (response?.data?.status === 'SUCCESS') {
                showSuccessToast(response?.data?.msg || 'Generated Successfully');
                setSelectedRows([]);
                getData();
            } else {
                showErrorToast(response?.response?.data?.msg || 'ERROR');
            }
        } catch (error) {
            showErrorToast(error?.msg || 'ERROR');
        }
    }, [generateCodPayable, getData, selectedRows, codPayables, destinationCountry, dateRangefil, deductible]);

    useEffect(() => {
        const savedGrid = sessionStorage.getItem(gridId);
        if (savedGrid) {
            const parsedData = JSON.parse(savedGrid);
            if (parsedData.columns) setCheckedCol(parsedData.columns.split(','));
        }
    }, [gridId]);

    useEffect(() => {
        sessionStorage.setItem(gridId, JSON.stringify({ grid_id: gridId, columns: checkedCol.join(',') }));
    }, [checkedCol, gridId]);

    const sorting = (name) => {
        const value = sortField?.startsWith('-') ? '' : '-';
        setSortField(value + name);
    };

    return (
        <>
            <div className="px-3 py-2">
                {/* Filters */}
                <div className="mb-2">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">Customer</Label>
                            <AsyncSearchInput
                                id="customer"
                                label="customer"
                                name="customer"
                                applySelectedStyles={true}
                                value={selectedOptionCustomer}
                                loadMoreOptions={loadMoreOptions}
                                shouldLoadMore={shouldLoadMore}
                                isMulti={true}
                                getOptionLabel={(zone) => zone.label}
                                getOptionValue={(zone) => zone.value}
                                onMenuOpen={handleMenuOpenregion}
                                onMenuClose={handleMenuCloseregion}
                                menuIsOpen={isReactselectRegion}
                                onChange={(selectedOptions) => {
                                    setSelectedOptionCustomer(selectedOptions);
                                    const selectedValues = Array.isArray(selectedOptions)
                                        ? selectedOptions.map((opt) => opt.value).join(', ')
                                        : '';
                                    setCustomer(selectedValues);
                                }}
                                placeholder="Customer"
                                onPaste={handlePaste}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                menuStyle={{ zIndex: 9999 }}
                                customStyles={{ control: { width: '100%', backgroundColor: '#f3f4f6' } }}
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">
                                Destination Country {tab === 1 && <span className="text-red-500">*</span>}
                            </Label>
                            <SearchInput
                                id="countryCode"
                                label="countryCode"
                                name="countryName"
                                applySelectedStyles={true}
                                value={selectedOptionCountry}
                                options={matchedCountries || []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.isoCode3}
                                handleChange={(selectedOption) => {
                                    setSelectedOptionCountry(selectedOption);
                                    setDestinationCountry(selectedOption ? selectedOption.isoCode3 : '');
                                }}
                                onMenuOpen={handleMenuOpenDesBulk}
                                onMenuClose={handleMenuCloseDesBulk}
                                menuIsOpen={isReactdesBulk}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Destination Country"
                                customStyles={{ control: { width: '100%', backgroundColor: '#f3f4f6' } }}
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">
                                Date {tab === 1 && <span className="text-red-500">*</span>}
                            </Label>
                            <DateRangePicker
                                format="yyyy-MM-dd"
                                placeholder="Select Date"
                                value={dateRange}
                                onChange={handleDateRangeChange}
                                placement="auto"
                                cleanable={false}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div>
                            <Label className="text-xs text-gray-600 mb-1 block">Include Deductible Only</Label>
                            <div className="toggle-switch-container mt-1">
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={deductible}
                                        onChange={() => setDeductible(!deductible)}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action Bar */}
                <div className="!mb-4">
                    <div className="flex justify-end items-center gap-2">
                        <Button
                            variant="outline"
                            onClick={() => {
                                setSelectedOptionCustomer(null);
                                setCustomer(null);
                                setSelectedOptionCountry(null);
                                setDestinationCountry(null);
                                setCodPayables([]);
                                setTotalCount(0);
                                setNewPage(0);
                            }}
                            className="!text-sm px-4 bg-white hover:!bg-gray-200"
                        >
                            Clear Filters
                        </Button>
                        <Button
                            onClick={handleApplyFilters}
                            className="bg-red-600 hover:bg-red-700 text-white !text-sm px-6"
                        >
                            <Search className="size-4 mr-2" />
                            Search
                        </Button>
                        {selectedRows?.length > 1 && (
                            <Button
                                onClick={handleBulkGenerate}
                                className="bg-red-600 hover:bg-red-700 text-white !text-sm px-4"
                            >
                                Bulk Generate
                            </Button>
                        )}
                        <Button
                            variant="outline"
                            size="icon"
                            title="Sync"
                            onClick={handleRefresh}
                            className="bg-white hover:!bg-gray-200 p-0"
                        >
                            <RefreshCw className="size-4" />
                        </Button>
                        <div ref={ref} className="customFilter">
                            <Dropdown autoClose="outside">
                                <Dropdown.Toggle id="dropdown-basic" className="!border !border-gray-200 !bg-white hover:!bg-gray-200 !rounded-md !p-2 !shadow-none !text-gray-700">
                                    <img alt="More actions" src={DotboldIcon} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                    <Dropdown.Item>
                                        <ul className="listColumn cursorPointer">
                                            {column?.map((d, i) => (
                                                <li key={d}>
                                                    <div className="smallCheckbox mb_4">
                                                        <input id={`product${i}`} type="checkbox" checked={!checkedCol.includes(d)} />
                                                        <label htmlFor={`product${i}`} onClick={() => handleSelect(d)}>{d}</label>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                <PaginationMainTable
                    pageSize={size}
                    setPageSize={handlePageSizeChange}
                    pageSizeOptions={[20, 50, 100]}
                    hasNext={(newPage + 1) * size < totalCount}
                    hasPrev={newPage > 0}
                    onNextPage={handleNextPage}
                    onPreviousPage={handlePreviousPage}
                    isLoadingPage={isLoadingPage}
                    loadingLabel="Loading COD payables"
                    onCancelLoading={listLoad.cancel}
                    cancelled={listLoad.cancelled}
                    pageNo={newPage}
                    wrapperClassName="rounded-lg border border-gray-200 overflow-hidden"
                >
                    <TableComponent
                        tableData={codPayables}
                        restrict={checkedCol}
                        newPage={newPage}
                        size={size}
                        sortField={sortField}
                        sorting={sorting}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        from={dateRangefil?.start}
                        to={dateRangefil?.end}
                        destinationCountry={destinationCountry}
                        includeDeductible={deductible}
                        onViewClick={handleViewClick}
                        fetchPageData={getData}
                        isLoadingPage={isLoadingPage}
                    />
                </PaginationMainTable>
            </div>

            <CodPayableDetailModal
                open={openViewModal}
                onClose={() => {
                    setOpenViewModal(false);
                    setCodPayableDetails(null);
                    setModalSummaryItem(null);
                    modalViewItemRef.current = null;
                }}
                summary={modalSummaryItem}
                details={codPayableDetails}
                isLoading={isModalLoading}
                isSummaryLoading={isSummaryLoading}
                page={modalPage}
                size={modalSize}
                hasNext={modalHasNext}
                onPreviousPage={handleModalPrevPage}
                onNextPage={handleModalNextPage}
                onSizeChange={handleModalSizeChange}
            />
        </>
    );
};

export default CodPayables;
